import { DateRange } from "react-day-picker";

/**
 * WMS1060_R01 출하현황 조회 DTO
 * 
 * - 조회 결과 필드
 * - 검색 조건 필드
 */

export interface WMS1060_R01Dto {
    // ========================================
    // 조회 결과 필드
    // ========================================
    
    inoutType: string;        // 구분 (IN/OUT)
    transportDt: string;      // 수불일자/출하일 (API: yyyy-MM-dd, LocalDate)
    transportNo: string;      // 수불번호 (내부용)
    inoutClass: string;       // 입출고구분 코드
    inoutClassNm: string;     // 수불유형
    
    logicCenter: string;      // 물류센터 코드
    logicCenterNm: string;    // 물류센터명
    
    warehouseCd: string;      // 창고코드
    warehouseNm: string;      // 창고명
    
    customCd: string;         // 거래처코드
    customNm: string;         // 상호 (거래처명)
    
    itemCd: string;           // 품목코드
    itemNm: string;           // 품명
    itemSpec: string;         // 규격
    locationCd?: string;
    locationNm?: string;
    
    itemStatus: string;       // 등급 코드
    itemStatusNm: string;     // 등급명
    
    unit: string;             // 단위
    
    qty: number;              // 출고량
    amt: number;              // 출하금액 (내부용)
    
    basOrderNo: string;       // 출고요청번호 (내부용)
    remark: string;           // 비고
    
    // ========================================
    // 그리드 전용 필드
    // ========================================
    
    valueIndex?: number;      // 그리드 행 ID (optional)
    inserted?: boolean;       // 삽입 여부 (그리드 표시용)
    isModified?: boolean;     // 수정 여부 (그리드 표시용)
}

/**
 * WMS1060_R01 검색 조건
 */
export interface WMS1060_R01Filter {
    dateRange: DateRange | undefined;  // 기간 검색
    logicCenter: string;               // 물류센터
    warehouseCd: string;               // 창고코드
    inoutType: string;                 // 입출고분류 (IN/OUT)
    inoutClass: string;                // 수불유형
    itemGroup: string;                 // 품목그룹
    customCd: string;                  // 거래처코드
    customNm: string;                  // 거래처명
    itemCd: string;                    // 품목코드
    itemNm: string;                    // 품목명
}

/**
 * 기본값
 */
export const defaultWMS1060_R01Dto: WMS1060_R01Dto = {
    inoutType: '',
    transportDt: '',
    transportNo: '',
    inoutClass: '',
    inoutClassNm: '',
    logicCenter: '',
    logicCenterNm: '',
    warehouseCd: '',
    warehouseNm: '',
    customCd: '',
    customNm: '',
    itemCd: '',
    itemNm: '',
    itemSpec: '',
    locationCd: '',
    locationNm: '',
    itemStatus: '',
    itemStatusNm: '',
    unit: '',
    qty: 0,
    amt: 0,
    basOrderNo: '',
    remark: '',
    valueIndex: 0,
    inserted: false,
    isModified: false,
};

/**
 * 기본 검색 조건
 */
export const defaultWMS1060_R01Filter: WMS1060_R01Filter = {
    dateRange: {
        from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        to: new Date()
    },
    logicCenter: '',
    warehouseCd: '',
    inoutType: '',                  // 기본값: 출고
    inoutClass: '',
    itemGroup: '',
    customCd: '',
    customNm: '',
    itemCd: '',
    itemNm: '',
};
